import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	itemNewQueue: {
		id: 'spa-apps-sidebar-servicedesk.common.practice-queues.item-new-queue',
		defaultMessage: 'New queue',
		description: 'Navigation item which opens page to create a new queue',
	},
	itemQueueSettings: {
		id: 'spa-apps-sidebar-servicedesk.common.practice-queues.item-queue-settings',
		defaultMessage: 'Queue settings',
		description: 'Navigation item which navigates to the Queue settings page',
	},
	addons: {
		id: 'spa-apps-sidebar-servicedesk.common.practice-queues.addons',
		defaultMessage: 'Add-ons',
		description: 'Header for add-ons section',
	},
	fetchQueuesError: {
		id: 'spa-apps-sidebar-servicedesk.common.practice-queues.fetch-queues-error',
		defaultMessage: "We're unable to load queues data, <button>try again.</button>",
		description: 'Error message when fail to fetch priority group data in sidebar',
	},
	queuesGroupErrorHeading: {
		id: 'spa-apps-sidebar-servicedesk.common.practice-queues.queues-group-error-heading',
		defaultMessage: 'Queue Groups',
		description: 'telling users that an error has occurred',
	},
	queuesGroupErrorBody: {
		id: 'spa-apps-sidebar-servicedesk.common.practice-queues.queues-group-error-body',
		defaultMessage: "We're unable to load queue groups data, <button>try again.</button>",
		description: 'Suggest an action to the user',
	},
});
